import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { FiArrowLeft } from 'react-icons/fi';
import MidNavBar from '../common/MidNavBar';
import ProductCard from '../common/ProductCard';
import './CatalogPage.css';

export default function CatalogPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const limit = 12;

  const q = searchParams.get('q') || '';
  const sort = searchParams.get('sort') || '';
  const filter = searchParams.get('filter') || '';
  const category = searchParams.get('category') || '';
  const type = searchParams.get('type') || '';

  const fetchProducts = useCallback(async (pg = 1, append = false) => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (q) params.set('q', q);
      if (sort) params.set('sort', sort);
      if (filter) params.set('filter', filter);
      if (category) params.set('category', category);
      if (type) params.set('type', type);
      params.set('page', pg); params.set('limit', limit);
      const res = await axios.get(`/api/products?${params}`);
      const newProds = res.data.products || [];
      setProducts(prev => append ? [...prev, ...newProds] : newProds);
      setHasMore(newProds.length === limit);
    } catch { setProducts([]); }
    finally { setLoading(false); }
  }, [q, sort, filter, category, type]);

  useEffect(() => { setPage(1); fetchProducts(1, false); }, [fetchProducts]);

  const loadMore = () => {
    const next = page + 1;
    setPage(next); fetchProducts(next, true);
  };

  const heading = type ? `${category} › ${type}` : category || (q ? `Results: "${q}"` : 'All Products');

  return (
    <div className="page-container">
      <div className="catalog-top-head">
        <button className="back-btn" onClick={() => navigate(-1)}><FiArrowLeft size={20}/></button>
        <div className="catalog-logo" onClick={() => navigate('/')}>Abhiras</div>
        <span className="catalog-heading-label">{heading}</span>
      </div>
      <MidNavBar initialSearch={q} initialSort={sort} initialFilter={filter} />
      <div className="catalog-page-grid">
        {loading && products.length === 0
          ? Array(12).fill(0).map((_, i) => <div key={i} className="product-skeleton" />)
          : products.map(p => <ProductCard key={p.product_id} product={p} />)
        }
        {!loading && products.length === 0 && (
          <div className="no-results">No products found. Try a different search or filter.</div>
        )}
      </div>
      {hasMore && !loading && (
        <div className="load-more-wrap">
          <button className="btn-outline" onClick={loadMore}>Load More</button>
        </div>
      )}
      {loading && products.length > 0 && <div className="loading-bar" />}
    </div>
  );
}
